import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NOB from '../../../constants/language-strings';
import SlideInPage from '../../../components/SlideInPage/SlideInPage';
import { WorkOrderHistoryItem } from '../components/work-order-history-item';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import { useWorkOrderHistory } from '../api';
import { ErrorNotification } from 'components/error-notification/error-notification';
const Container = styled.div `
  margin: 0 15px;
`;
const StyledHeading = styled.h1 `
  padding-top: 10px;
  margin: 0 15px;
  color: #1e1c1e;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
`;
const HistoryListWrapper = styled.div `
  padding: 10px;
  margin-top: 5px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 5px #0000001a;
`;
const HistoryList = styled.div `
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
export const WorkOrderHistoryContainer = () => {
    const { state } = useLocation();
    const workOrderId = state === null || state === void 0 ? void 0 : state.id;
    const { workOrderHistory, isWorkOrderHistoryFetching } = useWorkOrderHistory(workOrderId);
    return (_jsx(SlideInPage, { mainHeading: NOB.WORKORDER_HISTORY.WORKORDER_HISTORY, showLeftIcon: true, isFetching: isWorkOrderHistoryFetching, children: !workOrderHistory || workOrderHistory.length === 0 ? (_jsx(ErrorNotification, { title: NOB.FEEDBACKS.SORRY, text: NOB.WORKORDER_HISTORY.NO_WORKORDER_HISTORY })) : (_jsxs(Container, { children: [_jsxs(StyledHeading, { children: [NOB.WORKORDER_HISTORY.WORKORDER_ID, " ", workOrderId] }), _jsx(HistoryListWrapper, { children: _jsx(HistoryList, { children: workOrderHistory.map((item, index) => (_jsx(WorkOrderHistoryItem, { workOrderHistoryItem: item }, index))) }) })] })) }));
};
